export default "__VITE_ASSET__aVerCF0S__"